import { dropBoolean, dropModulos } from 'utils/drops';

const getCondicoesDePagamentoFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'modulo',
    label: 'Módulo',
    type: 'select',
    options: dropModulos,
    multiple: true,
  },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'ativo', label: 'Ativo', type: 'select', options: dropBoolean },
];

export default getCondicoesDePagamentoFilterFields;
